import {store} from '@components/Test/Context';
import {SHORT} from '@constants/test';
import classNames from 'classnames';
import type {ReactElement} from 'react';
import {useContext} from 'react';

interface Props {
    type?: string;
    text: string;
    modifier: string;
}

export default function TextOption(props: Props): ReactElement<Props> {
    const {currentState} = useContext(store);
    const classes = classNames({
        'text-option': true,
        'text-option--short': props.type === SHORT,
        [`text-option--${props.modifier}`]: currentState.isChecked,
    });

    return <div className={classes} dangerouslySetInnerHTML={{__html: props.text}} />;
}
